<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>主缆除湿</h2>
      </div>
      <div class="cable-main">
        <div class="dir left-dir">
          <h1 class="dir-text">{{ stationName }}</h1>
        </div>

        <div class="cable-img">
          <div class="stati sta-control-area">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_humidity("", humidityTooltipErrorControlArea, humidityAllowedMaxControlArea) }} <br />
                {{
                  assembleTooltip_device("控制箱", "NA", [
                    { flag: malfunctionDehumidifer, desc: "除湿机报警" },
                    { flag: malfunctionPower, desc: "电源故障" },
                  ])
                }}
              </div>
              <div :class="errorControlArea" class="state-info no-pos">
                <p class="sta-title">
                  控制箱:
                  {{
                    assembleBriefStatus("NA", [
                      { flag: malfunctionDehumidifer, desc: "除湿机报警" },
                      { flag: malfunctionPower, desc: "电源故障" },
                    ])
                  }}
                </p>
                <div class="sta-data-line-double">
                  <span class="sta-data-line-item">
                    <span>湿度: </span>
                    <span>{{ humidityControlArea | toFixed }}%</span>
                  </span>
                  <span class="sta-data-line-item">
                    <span>温度: </span>
                    <span>{{ temperatureControlArea | toFixed }}°C</span>
                  </span>
                </div>
                <div class="sta-data-line-single">
                  <span>采集电流: </span>
                  <span>{{ currentDehumidifier | toFixed }}A</span>
                </div>
                <div class="sta-data-line-single">
                  <span>脱扣器: </span>
                  <span>{{ runningTripUnit | toRunningDescription }}</span>
                </div>
                <div class="sta-data-line-single">
                  <span>脱扣器: </span>
                  <span>{{ runningTimeTripUnit }}</span>
                </div>
              </div>
            </el-tooltip>
          </div>

          <div class="stati sta-front-filter">
            <el-tooltip effect="light" placement="bottom">
              <div :class="errorControlArea" class="state-info no-pos">
                <p class="sta-title">前置过滤</p>
                <div class="sta-data-line-single">
                  <span>新风: </span>
                  <span>{{ temperatureNewAir | toFixed }}°C</span>
                </div>
                <div class="sta-data-line-single">
                  <span>再生进风: </span>
                  <span>{{ temperatureRegenerateAirInput | toFixed }}°C</span>
                </div>
                <div class="sta-data-line-single">
                  <span>除湿过滤: </span>
                  <span>{{ pressureDehumidiferFilter | toFixed }}Pa</span>
                </div>
                <div class="sta-data-line-single">
                  <span>回风过滤: </span>
                  <span>{{ pressureReturnAirFilter | toFixed }}Pa</span>
                </div>

                <!-- <div class="sta-data-line-double">
                  <span class="sta-data-line-item">
                    <span>除湿过滤: </span>
                    <span>{{ pressureDehumidiferFilter | toFixed }}Pa</span>
                  </span>
                  <span class="sta-data-line-item">
                    <span>回风过滤: </span>
                    <span>{{ pressureReturnAirFilter | toFixed }}Pa</span>
                  </span>
                </div>
                <div class="sta-data-line-double">
                  <span class="sta-data-line-item">
                    <span>新风: </span>
                    <span>{{ temperatureNewAir | toFixed }}°C</span>
                  </span>
                  <span class="sta-data-line-item">
                    <span>再生进风: </span>
                    <span>{{ temperatureRegenerateAirInput | toFixed }}°C</span>
                  </span>
                </div> -->
              </div>
            </el-tooltip>
          </div>

          <!-- <div class="stati sta-front-table">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_device("前置表冷", runningFrontTable, []) }}
              </div>
              <div :class="errorFrontTable" class="state-info no-pos">
                <p class="sta-title">
                  前置表冷:
                  {{ assembleBriefStatus(runningFrontTable, []) }}
                </p>
                <div class="sta-data-line-double">
                  <span class="sta-data-line-item">
                    <span>前表: </span>
                    <span>{{ runningFrontTable | toRunningDescription }}</span>
                  </span>
                  <span class="sta-data-line-item">
                    <span>电磁阀霜化: </span>
                    <span>{{ runningFrontTableFrosting | toRunningDescription }}</span>
                  </span>
                </div>

                <div class="sta-data-line-single">
                  <span>前表: </span> <span>{{ runningTimeFrontTable }}</span>
                </div>
                <div class="sta-data-line-single">
                  <span>电磁阀霜化: </span>
                  <span>{{ runningTimeFrontTableFrosting }}</span>
                </div>
              </div>
            </el-tooltip>
          </div> -->

          <div class="stati sta-regenerate">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_device("除湿再生", runningRegenerateWheel, [
                    { flag: malfunctionRegenerateHeatOverheat, desc: "再生加热超温保护" },
                    { flag: malfunctionRegenerateAirExit, desc: "再生排风超温保护" },
                    { flag: malfunctionRegenerateFan, desc: "再生风机过载" },
                    { flag: malfunctionRegenerateHeatDry, desc: "再生加热干保护" },
                    { flag: malfunctionRegenerateBox, desc: "再生箱超温报警" },
                    { flag: malfunctionReducer, desc: "减速机过载" },
                  ])
                }}
              </div>
              <div :class="errorRegenerate" class="state-info no-pos">
                <p class="sta-title">
                  除湿再生:
                  {{
                    assembleBriefStatus(runningRegenerateWheel, [
                      { flag: malfunctionRegenerateHeatOverheat, desc: "再生加热超温保护" },
                      { flag: malfunctionRegenerateAirExit, desc: "再生排风超温保护" },
                      { flag: malfunctionRegenerateFan, desc: "再生风机过载" },
                      { flag: malfunctionRegenerateHeatDry, desc: "再生加热干保护" },
                      { flag: malfunctionRegenerateBox, desc: "再生箱超温报警" },
                      { flag: malfunctionReducer, desc: "减速机过载" },
                    ])
                  }}
                </p>
                <div class="sta-data-line-double">
                  <span class="sta-data-line-item">
                    <span>再生排风: </span>
                    <span>{{ temepratureRegenerateAirExit | toFixed }}°C</span>
                  </span>
                  <span class="sta-data-line-item">
                    <span>再生风机: </span>
                    <span>{{ pressureRegenerateFan | toFixed }}Pa</span>
                  </span>
                </div>
                <div class="sta-data-line-double">
                  <span class="sta-data-line-item">
                    <span>再生加热: </span>
                    <span>{{ temperatureRegenerateHeating | toFixed }}°C</span>
                  </span>
                  <span class="sta-data-line-item">
                    <span>再生加热: </span>
                    <span>{{ runningRegenerateHeating | toRunningDescription }}</span>
                  </span>
                </div>
                <div class="sta-data-line-double">
                  <span class="sta-data-line-item">
                    <span>转轮计数: </span>
                    <span>{{ countRegenerateWheel | toNumber }}圈</span>
                  </span>
                  <span class="sta-data-line-item">
                    <span>再生转轮: </span>
                    <span>{{ runningRegenerateWheel | toRunningDescription }}</span>
                  </span>
                </div>
                <div class="sta-data-line-single">
                  <span>再生加热: </span>
                  <span>{{ runningTimeRegenerateHeating }}</span>
                </div>
                <div class="sta-data-line-single">
                  <span>再生转轮: </span>
                  <span>{{ runningTimeRegenerateWheel }}</span>
                </div>
              </div>
            </el-tooltip>
          </div>

          <div class="stati sta-main-fan">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_device("主风机", runningMainFan, [{ flag: malfunctionMainFan, desc: "主风机缺风保护" }]) }}
              </div>
              <div :class="errorAirFan" class="state-info no-pos">
                <p class="sta-title">
                  主风机:
                  {{ assembleBriefStatus(runningMainFan, [{ flag: malfunctionMainFan, desc: "主风机缺风保护" }]) }}
                </p>
                <!-- <div class="sta-data-line-single">
                  <span>主风机: </span>
                  <span>{{ runningMainFan | toRunningDescription }}</span>
                </div> -->
                <div class="sta-data-line-single">
                  <span>主风机: </span>
                  <span>{{ runningTimeMainFan }}</span>
                </div>
              </div>
            </el-tooltip>
          </div>


          <div class="stati sta-air-fan">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_device("加压风机", runningAirFan, []) }}
              </div>
              <div :class="errorAirFan" class="state-info no-pos">
                <p class="sta-title">
                  加压风机:
                  {{ assembleBriefStatus(runningAirFan, []) }}
                </p>
                <!-- <div class="sta-data-line-single">
                  <span>加压风机: </span>
                  <span>{{ runningAirFan | toRunningDescription }}</span>
                </div> -->
                <div class="sta-data-line-single">
                  <span>加压风机: </span>
                  <span>{{ runningTimeAirFan }}</span>
                </div>
              </div>
            </el-tooltip>
          </div>

          <div class="stati sta-environment">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_humidity(sensorName1, humidityTooltipErrorSensor1, humidityAllowedMaxSensor1) }} <br />
                {{ assembleTooltip_humidity(sensorName2, humidityTooltipErrorSensor2, humidityAllowedMaxSensor2) }} <br />
                {{ assembleTooltip_humidity(sensorName3, humidityTooltipErrorSensor3, humidityAllowedMaxSensor3) }} <br />
                {{ assembleTooltip_humidity(sensorName4, humidityTooltipErrorSensor4, humidityAllowedMaxSensor4) }} <br />
                {{ assembleTooltip_humidity(sensorNameTotal, humidityTooltipErrorSensor1234Max, humidityAllowedMaxSensor1234Max) }} <br />
              </div>
              <div :class="errorEnvironment" class="state-info no-pos">
                <p class="sta-title">{{ environmentTitle }}</p>
                <div class="sta-data-line-single">
                  <span>{{ sensorName1 }} </span>
                  <span class="sta-data-line-single-value">
                    <span>{{ temperatureSensor1 | toFixed }}°C </span>
                    <span>{{ humiditySensor1 | toFixed }}% </span>
                  </span>
                </div>
                <div class="sta-data-line-single">
                  <span>{{ sensorName2 }} </span>
                  <span class="sta-data-line-single-value">
                    <span>{{ temperatureSensor2 | toFixed }}°C </span>
                    <span>{{ humiditySensor2 | toFixed }}% </span>
                  </span>
                </div>
                <div class="sta-data-line-single">
                  <span>{{ sensorName3 }} </span>
                  <span class="sta-data-line-single-value">
                    <span>{{ temperatureSensor3 | toFixed }}°C </span>
                    <span>{{ humiditySensor3 | toFixed }}% </span>
                  </span>
                </div>
                <div class="sta-data-line-single">
                  <span>{{ sensorName4 }} </span>
                  <span class="sta-data-line-single-value">
                    <span>{{ temperatureSensor4 | toFixed }}°C </span>
                    <span>{{ humiditySensor4 | toFixed }}% </span>
                  </span>
                </div>
                <div class="sta-data-line-single">
                  <span>{{sensorNameTotal}} </span>
                  <span>{{ humiditySensor1234Max | toFixed }}%</span>
                </div>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
      
      <script>
import configJson from "./config/station.json";

export default {
  name: "gasClamp",
  data() {
    return {
      loading: true,
      timer: null,

      deviceList: [],
      stationName: "",
      stationId: "",
      stationLocation: "",
      stationIndex: "",
      isMidTower: false,

      //humidity, temperature, pressure, flow , running time, running flag, malfunction and others...
      humidityControlArea: "--",
      humiditySensor1: "--",
      humiditySensor2: "--",
      humiditySensor3: "--",
      humiditySensor4: "--",
      humiditySensor1234Max: "--",

      temperatureControlArea: "--",
      temperatureSensor1: "--",
      temperatureSensor2: "--",
      temperatureSensor3: "--",
      temperatureSensor4: "--",
      temperatureRegenerateHeating: "--",
      temepratureRegenerateAirExit: "--",
      temperatureNewAir: "--",
      temperatureRegenerateAirInput: "--",

      pressureRegenerateFan: "--",
      pressureDehumidiferFilter: "--",
      pressureReturnAirFilter: "--",

      currentDehumidifier: "--",

      countRegenerateWheel: "--",

      runningTimeMainFan: "--",
      runningTimeRegenerateWheel: "--",
      runningTimeFrontTable: "--",
      runningTimeAirFan: "--",
      runningTimeFrontTableFrosting: "--",
      runningTimeRegenerateHeating: "--",
      runningTimeTripUnit: "--",

      runningMainFan: "--",
      runningRegenerateWheel: "--",
      runningFrontTable: "--",
      runningAirFan: "--",
      runningFrontTableFrosting: "--",
      runningRegenerateHeating: "--",
      runningTripUnit: "--",

      malfunctionDehumidifer: "--",
      malfunctionPower: "--",
      malfunctionMainFan: "--",
      malfunctionRegenerateFan: "--",
      malfunctionReducer: "--",
      malfunctionRegenerateHeatOverheat: "--",
      malfunctionRegenerateAirExit: "--",
      malfunctionRegenerateHeatDry: "--",
      malfunctionRegenerateBox: "--",

      //error
      errorControlArea: "--",
      errorFrontFilter: "--",
      errorFrontTable: "--",
      errorRegenerate: "--",
      errorAirFan: "--",
      errorMainFan: "--",
      errorEnvironment: "--",

      //humidity allowed max
      humidityAllowedMaxControlArea: "--",
      humidityAllowedMaxSensor1: "--",
      humidityAllowedMaxSensor2: "--",
      humidityAllowedMaxSensor3: "--",
      humidityAllowedMaxSensor4: "--",
      humidityAllowedMaxSensor1234Max: "--",

      //humidity tooltip error
      humidityTooltipErrorControlArea: "--",
      humidityTooltipErrorSensor1: "--",
      humidityTooltipErrorSensor2: "--",
      humidityTooltipErrorSensor3: "--",
      humidityTooltipErrorSensor4: "--",
      humidityTooltipErrorSensor1234Max: "--",

      dataNameDeviceNameDict: {
        humidityControlArea: "除湿机控制区域湿度",
        humiditySensor1: "1#传感器湿度",
        humiditySensor2: "2#传感器湿度",
        humiditySensor3: "3#传感器湿度",
        humiditySensor4: "4#传感器湿度",
        humiditySensor1234Max: "1-4#传感器湿度最大值",

        temperatureControlArea: "除湿机控制区域温度",
        temperatureSensor1: "1#传感器温度",
        temperatureSensor2: "2#传感器温度",
        temperatureSensor3: "3#传感器温度",
        temperatureSensor4: "4#传感器温度",
        temperatureRegenerateHeating: "再生加热温度",
        temepratureRegenerateAirExit: "再生排风温度",
        temperatureNewAir: "新风温度",
        temperatureRegenerateAirInput: "再生进风温度",

        pressureRegenerateFan: "再生风机压差",
        pressureDehumidiferFilter: "除湿过滤压差",
        pressureReturnAirFilter: "回风过滤压差",

        currentDehumidifier: "除湿机采集电流",

        countRegenerateWheel: "转轮计数",

        runningTimeMainFan: "主风机运行时间",
        runningTimeRegenerateWheel: "再生转轮运行时间",
        runningTimeFrontTable: "前表运行时间",
        runningTimeAirFan: "加压风机运行时间",
        runningTimeFrontTableFrosting: "前表电磁阀霜化运行时间",
        runningTimeRegenerateHeating: "再生加热运行时间",
        runningTimeTripUnit: "脱扣器运行时间",

        runningMainFan: "主风机运行",
        runningRegenerateWheel: "再生转轮运行",
        runningFrontTable: "前表开关",
        runningAirFan: "加压风机运行",
        runningFrontTableFrosting: "前表电磁阀霜化",
        runningRegenerateHeating: "再生加热运行",
        runningTripUnit: "脱扣器",

        malfunctionDehumidifer: "除湿机报警",
        malfunctionPower: "电源故障",
        malfunctionMainFan: "主风机缺风保护",
        malfunctionRegenerateFan: "再生风机过载",
        malfunctionReducer: "减速机过载",
        malfunctionRegenerateHeatOverheat: "再生加热超温保护",
        malfunctionRegenerateAirExit: "再生排风超温保护",
        malfunctionRegenerateHeatDry: "再生加热干保护",
        malfunctionRegenerateBox: "再生箱超温报警",
      },

      allowedMaxDataNameDeviceNameDict: {
        humidityAllowedMaxControlArea: "除湿机控制区域湿度",
        humidityAllowedMaxSensor1: "1#传感器湿度",
        humidityAllowedMaxSensor2: "2#传感器湿度",
        humidityAllowedMaxSensor3: "3#传感器湿度",
        humidityAllowedMaxSensor4: "4#传感器湿度",
        humidityAllowedMaxSensor1234Max: "1-4#传感器湿度最大值",
      },

      //humidity, temperature, pressure, flow , running time, running flag, malfunction and others... -> error
      dataNameErrorNameDict: {
        humidityControlArea: "errorControlArea",
        humiditySensor1: "errorEnvironment",
        humiditySensor2: "errorEnvironment",
        humiditySensor3: "errorEnvironment",
        humiditySensor4: "errorEnvironment",
        humiditySensor1234Max: "errorEnvironment",

        temperatureControlArea: "errorControlArea",
        temperatureSensor1: "errorEnvironment",
        temperatureSensor2: "errorEnvironment",
        temperatureSensor3: "errorEnvironment",
        temperatureSensor4: "errorEnvironment",
        temperatureRegenerateHeating: "errorRegenerate",
        temepratureRegenerateAirExit: "errorRegenerate",
        temperatureNewAir: "errorFrontFilter",
        temperatureRegenerateAirInput: "errorFrontFilter",

        pressureRegenerateFan: "errorRegenerate",
        pressureDehumidiferFilter: "errorFrontFilter",
        pressureReturnAirFilter: "errorFrontFilter",

        currentDehumidifier: "errorControlArea",

        countRegenerateWheel: "errorRegenerate",

        runningTimeMainFan: "errorAirFan",
        runningTimeRegenerateWheel: "errorRegenerate",
        runningTimeFrontTable: "errorFrontTable",
        runningTimeAirFan: "errorAirFan",
        runningTimeFrontTableFrosting: "errorFrontTable",
        runningTimeRegenerateHeating: "errorRegenerate",
        runningTimeTripUnit: "errorControlArea",

        runningMainFan: "errorAirFan",
        runningRegenerateWheel: "errorRegenerate",
        runningFrontTable: "errorFrontTable",
        runningAirFan: "errorAirFan",
        runningFrontTableFrosting: "errorFrontTable",
        runningRegenerateHeating: "errorRegenerate",
        runningTripUnit: "errorControlArea",

        malfunctionDehumidifer: "errorControlArea",
        malfunctionPower: "errorControlArea",
        malfunctionMainFan: "errorAirFan",
        malfunctionRegenerateFan: "errorRegenerate",
        malfunctionReducer: "errorRegenerate",
        malfunctionRegenerateHeatOverheat: "errorRegenerate",
        malfunctionRegenerateAirExit: "errorRegenerate",
        malfunctionRegenerateHeatDry: "errorRegenerate",
        malfunctionRegenerateBox: "errorRegenerate",
      },

      //malfunction -> error
      malfunctionDataNameErrorNameDict: {
        malfunctionDehumidifer: "errorControlArea",
        malfunctionPower: "errorControlArea",
        malfunctionMainFan: "errorAirFan",
        malfunctionRegenerateFan: "errorRegenerate",
        malfunctionReducer: "errorRegenerate",
        malfunctionRegenerateHeatOverheat: "errorRegenerate",
        malfunctionRegenerateAirExit: "errorRegenerate",
        malfunctionRegenerateHeatDry: "errorRegenerate",
        malfunctionRegenerateBox: "errorRegenerate",
      },

      //humidity -> humidity tooltip error
      dataNameTooltipErrorNameDict: {
        humidityControlArea: "humidityTooltipErrorControlArea",
        humiditySensor1: "humidityTooltipErrorSensor1",
        humiditySensor2: "humidityTooltipErrorSensor2",
        humiditySensor3: "humidityTooltipErrorSensor3",
        humiditySensor4: "humidityTooltipErrorSensor4",
        humiditySensor1234Max: "humidityTooltipErrorSensor1234Max",
      },

      //running time -> running time type (HOUR/MIN)
      dataNameRunningTimeTypeDict: {
        runningTimeMainFan: "MIN",
        runningTimeRegenerateWheel: "MIN",
        runningTimeFrontTable: "MIN",
        runningTimeAirFan: "MIN",
        runningTimeFrontTableFrosting: "MIN",
        runningTimeRegenerateHeating: "MIN",
        runningTimeTripUnit: "MIN",
      },
    };
  },
  computed: {
    environmentTitle: function () {
      return this.stationLocation + this.stationIndex + "站环境";
    },
    sensorName1: function () {
      return this.stationLocation + "除湿机(1#)";
    },
    sensorName2: function () {
      return this.stationLocation + "循环风上(2#)";
    },
    sensorName3: function () {
      return this.stationLocation + "循环风上(3#)";
    },
    sensorName4: function () {
      return this.stationLocation + "循环风上(4#)";
    },
    sensorNameTotal: function () {
      return this.stationLocation + "湿度最大值(1-4#)";
    },
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
    toNumber(val) {
      if (val === 0) return "0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(0);
    },
    toRunningDescription(val) {
      if (val === 0) return "停机";
      if (!Number(val)) return "--";
      if (val > 0) return "运行";
      return "N/A";
    },
  },
  created() {
    this.readConfig();
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
      this.resetData();
      this.readConfig();
      this.loading = true;
      this.getData();
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    resetData() {
      //pass
    },
    refreshData() {
      this.loading = true;
      this.getData();
    },
    readConfig() {
      const routerPath = this.$route.fullPath.split("/");
      const routerName = routerPath[3].toLowerCase();
      this.deviceList = configJson[routerName].deviceList;
      this.stationName = configJson[routerName].stationName;
      this.stationIndex = configJson[routerName].stationIndex;
      this.stationLocation = configJson[routerName].stationLocation;
      this.stationId = configJson[routerName].stationId;
      this.isMidTower = configJson[routerName].isMidTower;
    },
    findDeviceIdFromConfig(deviceName) {
      const device = this.deviceList.find((el) => {
        return el.deviceName === deviceName;
      });
      if (!device) {
        console.log(`deviceName${deviceName}###`);
        return "";
      }
      return device.deviceId;
    },
    translateRunningTime(runningTimeHour) {
      let day = runningTimeHour / 24;
      let hour = (day % 1) * 24;
      let min = (hour % 1) * 60;
      return Math.floor(day) + "天" + Math.floor(hour) + "时" + Math.floor(min) + "分";
    },
    getData() {
      this.resetError();
      let stationRequestList = [this.$http.get(`/deviceData/Station?stationId=${this.stationId}`)];

      this.$http.all(stationRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setDataAndError(res.data);
            this.loading = false;
          });
        })
      );
    },
    setDataAndError(stationData) {
      //device id not set (device id = 'GUID') = no data
      stationData["GUID"] = {
        dataId: null,
        deviceId: "GUID",
        value: null,
        createdDate: "0001-01-01T00:00:00",
        dataDate: "0001-01-01T00:00:00",
        dataType: "VALUE",
        errorLevel: "Warning",
      };

      for (let dataName in this.dataNameDeviceNameDict) {
        const deviceName = this.dataNameDeviceNameDict[dataName];
        const dataId = this.findDeviceIdFromConfig(deviceName);
        if (dataId !== "" && stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];
            this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }

          if (this.dataNameRunningTimeTypeDict[dataName] !== undefined && (stationData[dataId].value || stationData[dataId].value === 0)) {
            const type = this.dataNameRunningTimeTypeDict[dataName];
            let runningTime = stationData[dataId].value;
            if (type === "MIN") {
              runningTime = runningTime / 60.0;
            }
            this[dataName] = this.translateRunningTime(runningTime);
          }
        }
      }
    },
    getAllowedMax() {
      let stationMetaRequestList = [this.$http.get(`/bridge/StationInfo?stationId=${this.stationId}`)];

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDeviceDict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDeviceDict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxDataNameDeviceNameDict) {
        const deviceName = this.allowedMaxDataNameDeviceNameDict[allowedMaxName];
        const dataId = this.findDeviceIdFromConfig(deviceName);
        if (dataId !== "" && deviceIdDeviceDict[dataId] !== undefined) {
          let device = deviceIdDeviceDict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameDeviceNameDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    assembleTooltip_humidity(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if (
        (errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") &&
        allowedMax !== undefined &&
        allowedMax !== null &&
        !isNaN(parseInt(allowedMax))
      ) {
        if (allowedMax === 0) {
          result += "(无限制)";
        } else {
          result += "(<" + allowedMax + "%RH)";
        }
      }

      return result;
    },
    assembleTooltip_device(name, runningFlag, malfunctionList) {
      //malfunction list [ {flag, desc} ]
      let result = "";

      if (name && name !== "") {
        result = name + ": ";
      }

      if (runningFlag && runningFlag === "NA") {
        //无运行状态, 从报错清单获取是否中断
        let isWarning = false;
        if (malfunctionList && malfunctionList.length > 0) {
          for (let malfunctionItem of malfunctionList) {
            if (malfunctionItem.flag === "--" || malfunctionItem.flag === null) {
              isWarning = true;
              break;
            }
          }
        }

        if (isWarning) {
          result += "中断";
        } else {
          result += "正常";
        }
      } else if (runningFlag === "--" || runningFlag === null) {
        result += "中断";
      } else if (runningFlag === 0) {
        result += "停机";
      } else if (runningFlag && Number(runningFlag)) {
        if (Number(runningFlag) > 0) {
          result += "运行";
        } else {
          result += "N/A";
        }
      }

      if (malfunctionList && malfunctionList.length > 0) {
        for (let malfunctionItem of malfunctionList) {
          if (malfunctionItem.flag && Number(malfunctionItem.flag)) {
            let description = "故障";
            if (malfunctionItem.desc && malfunctionItem.desc !== "") {
              description = malfunctionItem.desc;
            }

            if (Number(malfunctionItem.flag) > 0) {
              result += ", " + description;
            }
          }
        }
      }

      return result;
    },
    assembleBriefStatus(runningFlag, malfunctionList, humidityErrorLevelList) {
      let result = "";
      if (malfunctionList && malfunctionList.length > 0) {
        for (let malfunctionItem of malfunctionList) {
          if (malfunctionItem.flag === "--" || malfunctionItem.flag === null) {
            result = "中断";
          } else if (malfunctionItem.flag && Number(malfunctionItem.flag) && Number(malfunctionItem.flag) > 0) {
            result = "报警";
          }
        }
      }

      if (result === "") {
        if (runningFlag === "NA") {
          result = "正常";
        } else if (runningFlag === 0) {
          result = "停机";
        } else if (Number(runningFlag)) {
          if (Number(runningFlag) > 0) {
            result = "运行";
          } else {
            result = "N/A";
          }
        }
      }

      if (result === "") {
        result = "中断";
      }

      return result;
    },
  },
};
</script>
      
      <style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }
  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}
@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }
  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}

.body-class {
  border: 1px solid red;
}

.tooltip-slot {
  line-height: 1.4;
}

.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
  // min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 96%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;
      min-height: 600px;

      h2 {
        padding: 0 10px;
        font-weight: 400;
        font-size: 24px;
        line-height: 35px;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      min-width: 1200px;
      min-height: 600px;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .sensor1:after {
          background: #c7798b;
        }
        .sensor2:after {
          background: #3376c7;
        }
      }
      .legend-right {
        position: absolute;
        left: 75px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .default:after {
          background: #ffff00;
        }
        .running:after {
          background: #67dd34;
        }
        .stopped:after {
          background: #a0a0a0;
        }
      }
      .legend-station {
        position: absolute;
        left: 73px;
        top: 108px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }
        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;
        i {
          font-size: 30px;
        }
        .dir-text {
          font-size: 20px;
        }
      }
      .left-dir {
        left: 150px;
      }
      .right-dir {
        flex-direction: row-reverse;
        right: 250px;
      }
      .cable-img {
        position: relative;
        z-index: 0;
        width: 1200px;
        height: 600px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../assets/image/jiashao/stationLine_upTower.png");
        background-position-y: 100%;

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
        }

        .station-block-left {
          top: 122px;
          left: 173px;
        }

        .station-block-middle {
          top: 122px;
          left: 582px;
        }

        .station-block-right {
          top: 122px;
          left: 990px;
        }

        .stati {
          position: absolute;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);
            &:before {
              background-color: #ed6a5a;
            }
            & > p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;
              &:first-child {
                font-size: 13px;
              }
            }
            &.no-pos:before {
              display: none;
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &.bottom-pos-sta:before {
              left: 50%;
              top: 95%;
              transform: translate(0%, 0%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }

            .sta-title {
              margin-bottom: 5px;
            }
            .sta-title::after {
              content: "";
              position: absolute;
              left: 0;
              top: 25px;
              width: 95%;
              height: 1px;
              background: #2a387a;
              transform: scaleY(0.5); /* 减小分割线的视觉影响 */
            }

            .sta-data-line-double {
              display: flex;
              justify-content: space-between;
              height: 20px;
            }
            .sta-data-line-item {
              display: flex;
              justify-content: space-between;
              width: 45%;
            }

            .sta-data-line-single {
              display: flex;
              justify-content: space-between;
              height: 20px;
            }

            .sta-data-line-single-value {
              display: flex;
              justify-content: space-between;
              width: 35%;
            }

            .valve-sign {
              margin-top: auto;
              margin-bottom: auto;
              width: 12px;
              height: 12px;
              background-color: #ffff00;
              animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
              border-radius: 10px;
              margin-left: 12px;

              &.running {
                background-color: #67dd34;
                animation: none;
              }
              &.stopped {
                background-color: #a0a0a0;
                animation: none;
              }
            }

            span.default {
              background: #ffff00;
            }
            span.running {
              background: #67dd34;
            }
            span.stopped {
              background: #a0a0a0;
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            & > p {
              margin: 0;
              white-space: nowrap;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &.bottom-pos:before {
              left: 50%;
              top: 90%;
              transform: translate(0%, 0%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
          &.sensor1 {
            background: #c7798b;
            &:after,
            &:before {
              background: #c7798b;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #c7798b;
              }
            }
          }
          &.sensor2 {
            background: #3376c7;
            &:after,
            &:before {
              background: #3376c7;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #3376c7;
              }
            }
          }
        }

        .sta-front-filter {
          top: 240px;
          left: 295px;
          &::before {
            bottom: 33px;
            left: -40px;
            width: 90px;
            transform: rotate(80deg);
            display: none;
          }
          &::after {
            bottom: 77px;
            left: -17px;
            display: none;
          }
          .state-info {
            right: 16px;
            top: -78px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 180px;
          }
        }

        .sta-front-table {
          top: 605px;
          left: 480px;
          &::before {
            bottom: 33px;
            left: -40px;
            width: 90px;
            transform: rotate(80deg);
            display: none;
          }
          &::after {
            bottom: 77px;
            left: -17px;
            display: none;
          }
          .state-info {
            right: 16px;
            top: -78px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 280px;
          }
        }

        .sta-regenerate {
          top: 170px;
          left: 665px;
          &::before {
            bottom: 33px;
            left: -40px;
            width: 90px;
            transform: rotate(80deg);
            display: none;
          }
          &::after {
            bottom: 77px;
            left: -17px;
            display: none;
          }
          .state-info {
            right: 16px;
            top: -78px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 320px;
          }
        }

        .sta-environment {
          top: 190px;
          left: 1210px;
          &::before {
            bottom: 33px;
            left: -40px;
            width: 90px;
            transform: rotate(80deg);
            display: none;
          }
          &::after {
            bottom: 77px;
            left: -17px;
            display: none;
          }
          .state-info {
            right: 16px;
            top: -78px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 260px;
          }
        }

        .sta-control-area {
          top: 340px;
          left: 970px;
          &::before {
            bottom: 33px;
            left: -40px;
            width: 90px;
            transform: rotate(80deg);
            display: none;
          }
          &::after {
            bottom: 77px;
            left: -17px;
            display: none;
          }
          .state-info {
            right: 16px;
            top: -78px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 220px;
          }
        }

        .sta-air-fan {
          top: 615px;
          left: 995px;
          &::before {
            bottom: 33px;
            left: -40px;
            width: 90px;
            transform: rotate(80deg);
            display: none;
          }
          &::after {
            bottom: 77px;
            left: -17px;
            display: none;
          }
          .state-info {
            right: 16px;
            top: -78px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 185px;
          }
        }

        .sta-main-fan {
          top: 595px;
          left: 605px;
          &::before {
            bottom: 33px;
            left: -40px;
            width: 90px;
            transform: rotate(80deg);
            display: none;
          }
          &::after {
            bottom: 77px;
            left: -17px;
            display: none;
          }
          .state-info {
            right: 16px;
            top: -78px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 185px;
          }
        }
      }
    }
  }
}
</style>